import { AGREEMENT_URL, PRIVACY_URL } from '../../constants/constants';
import '../styles/mobile-footer.css';

const MobileFooter = () => {
  const year = new Date().getFullYear();

  return (
    <div className="footerModal">
      <div id="linksInflo" className="linksInflo">
        <span style={{ color: '#a1a1a1' }}>
          {' '}
          &copy; Copyright {year} Inflo, Inc.
        </span>{' '}
        <a
          className="linkpaInflo"
          href={PRIVACY_URL}
          style={{ marginLeft: 20 }}
          target="_blank"
        >
          Privacy Policy
        </a>{' '}
        | &nbsp;
        <a className="linkpaInflo" href={AGREEMENT_URL} target="_blank">
          License Agreement
        </a>
      </div>
    </div>
  );
};

export default MobileFooter;
